import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { Tooltip as TooltipPrimitive } from 'radix-ui'
import { Button, Tooltip } from '@/ui'
import { mtc } from '@/styles'

interface HeaderButtonProps {
  icon: IconDefinition
  label: string
  onClick?: () => void
  showLabel?: boolean
  iconRight?: boolean
}

export const HeaderButton = ({
  icon,
  label,
  onClick,
  showLabel,
  iconRight,
}: HeaderButtonProps) => {
  const button = (
    <Button
      variant="ghost"
      size={showLabel ? 'sm' : 'square'}
      iconLeft={iconRight ? undefined : icon}
      iconRight={iconRight ? icon : undefined}
      iconRightClassName="text-current"
      onClick={onClick}
      aria-label={showLabel ? undefined : label}
      className={mtc(
        'text-xs text-[var(--adviser-text-muted)] hover:bg-moss-50 active:bg-moss-50',
        iconRight && 'pr-2.5'
      )}
    >
      {showLabel ? <span className="text-xs">{label}</span> : null}
    </Button>
  )

  if (showLabel) return button

  return (
    <TooltipPrimitive.Root delayDuration={500}>
      <Tooltip.Trigger asChild>{button}</Tooltip.Trigger>
      <TooltipPrimitive.Portal>
        <Tooltip.Content side="bottom" className="z-[9999]">
          {label}
        </Tooltip.Content>
      </TooltipPrimitive.Portal>
    </TooltipPrimitive.Root>
  )
}
